import { Button, Form, Modal } from 'react-bootstrap';
import React, { useCallback, useState } from 'react';

import { COLORS } from '../../../styles/colors';
import { DocumentTypeSelector } from '../../../components';
import { getTeacherValue } from '../../../helpers/getTeacherValue';
import styled from 'styled-components';
import { useDocumentTypeQuery } from '../../../generated/graphql';
import { useField } from 'formik';

interface DocumentTypeInputProps {
    name?: string;
    label?: string;
}

const TypeInputContainer = styled.div`
    margin-bottom: 1.5rem;
`;

const StyledLabel = styled(Form.Label)`
    font-weight: 600;
    color: ${COLORS.textPrimary};
    margin-bottom: 0.5rem;
`;

const InputRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0;
`;

const StyledInput = styled(Form.Control)`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background: ${COLORS.lightGray};
    color: ${COLORS.textPrimary};
    font-weight: 500;
    border-right: none;
`;

const StyledButton = styled(Button)`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background: ${COLORS.primary};
    border-color: ${COLORS.primary};
    color: ${COLORS.white};
    font-weight: 500;
    transition: all 0.2s ease;
    height: 100%;
    min-width: 180px;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    &:hover {
        background: ${COLORS.dark};
        border-color: ${COLORS.dark};
        color: ${COLORS.white};
    }
`;

const InfoText = styled.span`
    color: ${COLORS.textSecondary};
    font-size: 0.85rem;
    display: block;
    margin-top: 0.5rem;
`;

export const DocumentTypeInput: React.FC<DocumentTypeInputProps> = ({
    name = 'documentTypeId',
    label = 'Назва документу',
}) => {
    const [{ value }, meta, helpers] = useField({ name });

    const { data } = useDocumentTypeQuery({
        variables: { id: value || 0 },
        skip: !value,
    });

    const [showModal, setShowModal] = useState(false);
    const openModal = useCallback(() => {
        setShowModal(true);
    }, []);
    const hideModal = useCallback(() => {
        setShowModal(false);
        setDocumentTypeId(0);
    }, []);

    const [documentTypeId, setDocumentTypeId] = useState(0);
    const onDocumentTypeClick = useCallback(
        ({ id, isCategory }: any) => {
            if (isCategory) {
                return setDocumentTypeId(id);
            }
            helpers.setValue(id);
            hideModal();
        },
        [helpers, hideModal],
    );
    return (
        <>
            <TypeInputContainer>
                <StyledLabel>{label}</StyledLabel>
                <InputRow>
                    <StyledInput
                        value={data?.documentType.name}
                        disabled={true}
                    />
                    <StyledButton onClick={openModal}>
                        {data?.documentType ? 'Змінити документ' : 'Вибрати документ'}
                    </StyledButton>
                    {meta.touched && meta.error && (
                        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                    )}
                </InputRow>
                {data?.documentType && (
                    <>
                        <InfoText>
                            Категорія:{' '}
                            {data?.documentType.path
                                .filter((e) => ![0, value].includes(e.id))
                                .map((e) => e.name)
                                .join(' -> ')}
                        </InfoText>
                        <InfoText>
                            Кількість балів: {getTeacherValue(data.documentType.values)}
                        </InfoText>
                    </>
                )}
            </TypeInputContainer>
            <Modal show={showModal} onHide={hideModal} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Виберіть документ</Modal.Title>
                </Modal.Header>
                <DocumentTypeSelector documentTypeId={documentTypeId} onClick={onDocumentTypeClick} />
            </Modal>
        </>
    );
};
